import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import {
  updatePlayer,
  deletePlayer,
} from "../../../services/player.services.js";
import { isValidEmail } from "../../../utils/helper.js";
import { Checkbox } from "@mui/material";
import ErrorOverlay from "../../../UserComponents/overlays/ErrorOverlay.js";
// import SuccessOverlay from '../../../Usercomponents/overlays/SuccessOverlay';
import PositionsListOverlay from "../../../UserComponents/modals/PositionsList.js";
import ReactDOM from "react-dom";
import "./EditPlayer.css";
const initialState = {
  playerId: "",
  teamId: "",
  firstName: "",
  lastName: "",
  email: "",
  homeJersey: "",
  awayJersey: "",
  position1: "",
  position2: "",
  height: "",
  weight: "",
  grade: "",
  isCaptain: false,
};

const EditPlayerOverlay = (props) => {
  const user = useSelector((state) => state.auth.user);
  const [initialStateForm, setInitialStateForm] = useState(initialState);
  const [isFocused, setIsFocused] = useState(false);
  const [error, setError] = useState(null);
  const [loadingEdit, setLoadingEdit] = useState(false);
  const [loadingDel, setLoadingDel] = useState(false);
  const [pos1Visible, setPos1Visible] = useState(false);
  const [pos2Visible, setPos2Visible] = useState(false);
  const [successVisible, setSuccessVisible] = useState(false);

  const handleFormChange = (name, value) => {
    setInitialStateForm((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const toggleSuccessModal = () => {
    setSuccessVisible(!successVisible);
    props.handleGetPlayers();
    setTimeout(() => {
      props.onBackdropPress();
      setSuccessVisible(false);
    }, 2500);
  };

  const togglePosition1 = () => {
    console.log("Toggling Position 1 Overlay:", !pos1Visible);
    setPos1Visible(!pos1Visible);
  };

  const togglePosition2 = () => {
    console.log("Toggling Position 2 Overlay:", !pos2Visible);
    setPos2Visible(!pos2Visible);
  };

  useEffect(() => {
    if (props.data) {
      handleFormChange("playerId", props.data._id);
      handleFormChange("teamId", props.teamId);
      handleFormChange("firstName", props.data?.firstName);
      handleFormChange("lastName", props.data?.lastName);
      handleFormChange("homeJersey", props.data?.homeJersey);
      handleFormChange("awayJersey", props.data?.awayJersey);
      handleFormChange("position1", props.data?.position1);
      handleFormChange("position2", props.data?.position2);
      handleFormChange("height", props.data?.height);
      handleFormChange("weight", props.data?.weight);
      handleFormChange("grade", props.data?.grade);
      // handleFormChange("phone", props.data?.phone?.toString());
      // handleFormChange("email", props.data?.email);
    }
  }, [props.data]);

  const handleUpdate = async () => {
    try {
      // if (
      //   initialStateForm.email.length > 0 &&
      //   !isValidEmail(initialStateForm.email)
      // ) {
      //   throw new Error("Invalid email format!");
      // }
      setLoadingEdit(true);
      await updatePlayer(initialStateForm, user?.token);
      props.handleGetPlayers();
      props.onBackdropPress();
    } catch (e) {
      setError(e);
    } finally {
      setLoadingEdit(false);
    }
  };

  const handleDelete = async () => {
    try {
      setLoadingDel(true);
      await deletePlayer(props.data._id, user?.token);
      toggleSuccessModal();
    } catch (e) {
      setError(e);
    } finally {
      setLoadingDel(false);
    }
  };

  return (
    <div
      className={`modal ${props.isVisible ? "show" : ""}`}
      onClick={props.onBackdropPress}
    >
      {error && (
        <ErrorOverlay
          onBackdropPress={() => setError(null)}
          visible={!!error}
          error={error}
        />
      )}
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2 className="">EDIT A PLAYER</h2>
        </div>
        <div className="modal-body">
          <label className="checkbox-container full">
            Captain
            <input
              type="checkbox"
              checked={initialStateForm.isCaptain}
              onChange={() =>
                handleFormChange("isCaptain", !initialStateForm.isCaptain)
              }
            />
          </label>
          <div className="field-group">
            <label className="mainLabel">First Name:</label>
            <input
              className="input-field"
              type="text"
              value={initialStateForm.firstName}
              onChange={(e) => handleFormChange("firstName", e.target.value)}
            />
          </div>

          <div className="field-group">
            <label className="mainLabel">Last Name:</label>
            <input
              className="input-field"
              type="text"
              value={initialStateForm.lastName}
              onChange={(e) => handleFormChange("lastName", e.target.value)}
            />
          </div>

          <div className="field-group">
            <label className="mainLabel">Home Jersey #:</label>
            <input
              className="input-field"
              type="text"
              value={initialStateForm.homeJersey}
              onChange={(e) => handleFormChange("homeJersey", e.target.value)}
            />
          </div>

          <div className="field-group">
            <label className="mainLabel">Away Jersey #:</label>
            <input
              className="input-field"
              type="text"
              value={initialStateForm.awayJersey}
              onChange={(e) => handleFormChange("awayJersey", e.target.value)}
            />
          </div>

          <div className="field-group">
            <label className="mainLabel">Position 1:</label>
            <input
              className="input-field"
              type="text"
              value={initialStateForm.position1}
              readOnly
              onClick={togglePosition1}
            />
          </div>

          <div className="field-group">
            <label className="mainLabel">Position 2:</label>
            <input
              className="input-field"
              type="text"
              value={initialStateForm.position2}
              readOnly
              onClick={togglePosition2}
            />
          </div>

          <div className="field-group">
            <label className="mainLabel">Height:</label>
            <input
              className="input-field"
              type="text"
              value={initialStateForm.height}
              onChange={(e) => handleFormChange("height", e.target.value)}
            />
          </div>

          <div className="field-group">
            <label className="mainLabel">Weight:</label>
            <input
              className="input-field"
              type="text"
              value={initialStateForm.weight}
              onChange={(e) => handleFormChange("weight", e.target.value)}
            />
          </div>

          <div className="field-group">
            <label className="mainLabel">Grade:</label>
            <input
              className="input-field"
              type="text"
              value={initialStateForm.grade}
              onChange={(e) => handleFormChange("grade", e.target.value)}
            />
          </div>
        </div>

        <div className="modal-footer">
          <button className="btn-secondary" onClick={handleDelete}>
            {loadingDel ? "Deleting..." : "Delete Player"}
          </button>
          <button className="btn-primary" onClick={handleUpdate}>
            {loadingEdit ? "Saving..." : "Save"}
          </button>
        </div>

        <PositionsListOverlay
          onBackdropClick={togglePosition1}
          setPosition={(text) => handleFormChange("position1", text)}
          visible={pos1Visible}
        />
        <PositionsListOverlay
          onBackdropClick={togglePosition2}
          setPosition={(text) => handleFormChange("position2", text)}
          visible={pos2Visible}
        />

      </div>
    </div>
  );
};

export default EditPlayerOverlay;
